module.exports = __webpack_public_path__ + "img/upward-arrow.c40dc538.png";